<template>
  <v-card style="overflow: hidden">
    <v-row class="container-row" style="height: 100vh; overflow-y: auto">
      <!-- DETAILS -->
      <v-col>
        <v-toolbar flat color="#EBEFF3">
          <v-btn
            icon
            @click="closeDialog()"
            class="close-btn"
            color="#9AABB8"
            height="40"
            width="40"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Global Bank Odd -->
        <v-row>
          <v-col
            cols="12"
            class="details"
            style="padding-top: 0 !important; padding-bottom: 0 !important"
          >
            <v-row>
              <v-col class="market-total-col" v-if="isBigometro()">
                <div class="market-label">% Banca Total</div>
                <v-text-field
                  :value="totalBank + '%'"
                  dense
                  filled
                  readonly
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col class="market-total-col">
                <div class="market-label">Odd Total</div>
                <v-text-field
                  :value="totalOdd"
                  dense
                  filled
                  readonly
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Header (Date and Logos) -->
        <v-row
          v-for="(matchBet, index) in matchDetails.matchMarkets"
          :key="'comment-' + index"
        >
          <v-col cols="12" class="details">
            <v-row>
              <!-- Team Logos -->
              <v-col class="team-logos" cols="12">
                <div class="logos-container">
                  <v-list-item-avatar
                    class="team-icon"
                    size="72"
                    style="z-index: 1"
                  >
                    <v-img
                      :src="matchBet.match.homeTeam.image"
                      aspect-ratio="1"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-avatar class="team-icon" size="72">
                    <v-img
                      :src="matchBet.match.awayTeam.image"
                      aspect-ratio="1"
                    ></v-img>
                  </v-list-item-avatar>
                </div>
              </v-col>
              <!-- Date and Time -->
              <v-col class="match-details" cols="12">
                <v-list-item style="padding: 0">
                  <v-list-item-content style="padding: 0">
                    <v-list-item-subtitle class="green-label">{{
                      matchBet.match.competition.name
                    }}</v-list-item-subtitle>
                    <v-list-item-title class="team-names">{{
                      matchBet.match.homeTeam.name
                    }}</v-list-item-title>
                    <v-list-item-title class="team-names">{{
                      matchBet.match.awayTeam.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="match-date"
                      >{{ matchBet.match.hour }} .
                      {{ matchBet.match.date }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <!-- Labels -->
            <v-row class="chips-row">
              <v-col cols="12" style="padding-top: 4px">
                <v-chip label x-small>{{ matchBet.match.country.name }}</v-chip>
                <v-chip label x-small>{{ matchBet.match.sport.name }}</v-chip>
                <v-chip label x-small>{{
                  matchBet.match.competition.name
                }}</v-chip>
              </v-col>
            </v-row>
            <!-- PROGNOSTICS -->
            <v-row class="market-row">
              <v-col>
                <div
                  v-for="(market, index) in marketMap(matchBet.bigoddsMarkets)"
                  :key="'market-' + index"
                >
                  <div class="market-label">{{ index }}</div>
                  <v-row>
                    <v-col
                      class="market-bet"
                      v-for="(item, index) in market"
                      :key="'market-' + index"
                    >
                      <v-text-field
                        :class="
                          item.result == 'Certo'
                            ? 'outcome-success'
                            : item.result == 'Errado'
                            ? 'outcome-fail'
                            : ''
                        "
                        :placeholder="item.outcome"
                        dense
                        filled
                        readonly
                        :messages="
                          isBigometro()
                            ? 'Odd: ' + item.odd + ', Banca: ' + item.bank + '%'
                            : 'Odd: ' + item.odd
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.container-row {
  background-color: #ebeff3;
}
.close-btn {
  background: #d8e0e6;
  color: #9aabb8;
  margin-left: 0 !important;
}
.details {
  position: relative;
  padding: 24px 120px;
}
.team-logos {
  padding: 0;
}
.logos-container {
  position: absolute;
  right: 120px;
  padding-top: 36px;
}
.team-icon {
  margin: 0 !important;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 0 9px #f7f9fa;
  box-shadow: 0 0 0 9px #f7f9fa;
}
.team-icon >>> .v-image__image {
  background-size: 32px !important;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e !important;
  padding-right: 4px;
  margin-bottom: 8px !important;
}
.team-names {
  font-family: Gilroy-Bold;
  font-size: 32px;
  line-height: 40px;
  color: #304351 !important;
}
.match-date {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 14px;
  color: #bcc5cc !important;
  margin-top: 8px !important;
}
.black-label {
  font-family: Gilroy-Bold;
  font-size: 16px;
  line-height: 24px;
  color: #304351;
}
.v-chip {
  background-color: #d8e0e6 !important;
}
.market-row {
  margin-top: 8px;
}
.market-label {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 16px;
  color: #304351;
}
.market-bet {
  flex: 0 0 20%;
  max-width: 20%;
}
.market-bet >>> .v-input__slot {
  background-color: #d8e0e6 !important;
  border-radius: 4px !important;
}
.market-bet >>> .v-input__slot::before,
.market-bet >>> .v-input__slot::after,
.market-total-col >>> .v-input__slot::before,
.market-total-col >>> .v-input__slot::after {
  display: none !important;
}
.market-bet >>> input::placeholder {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 20px;
  color: #9aabb8 !important;
}
.market-bet >>> .v-text-field__details {
  padding: 4px 12px 0 0 !important;
}
.market-bet >>> .v-messages__message {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 20px;
  color: #9aabb8 !important;
}
.market-total-col {
  flex: 0 0 144px;
  max-width: 144px;
}
.market-total-col >>> .v-input__slot {
  background-color: #ffffff !important;
  border-radius: 4px !important;
  height: 56px;
}
.market-total-col >>> input {
  font-family: Gilroy-Bold;
  font-size: 24px;
  line-height: 40px;
  color: #304351 !important;
}
.market-total-col .market-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #6d818f;
}
.submit-row .col {
  width: 180px;
  flex: 0 0 180px;
  max-width: 180px;
}
input {
  color: #9aabb8;
}
.outcome-success >>> .v-input__slot {
  background: rgba(38, 171, 94, 0.3) !important;
}
.outcome-success >>> input::placeholder {
  color: #26ab5e !important;
}
.outcome-fail >>> .v-input__slot {
  background: rgba(248, 48, 48, 0.3) !important;
}
.outcome-fail >>> input::placeholder {
  color: #f83030 !important;
}
@media only screen and (max-height: 1024px) {
  .container-row {
    height: initial;
  }
  .details {
    padding: 24px 32px;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .team-logos {
    padding: 12px 24px;
  }
  .logos-container {
    position: relative;
    right: 0;
    padding-top: 0;
  }
  .market-label {
    margin-top: 24px !important;
  }
  .market-bet {
    flex: 0 0 100%;
    max-width: 100%;
    padding-bottom: 0 !important;
  }
  .market-bet:nth-child(2) {
    padding-top: 0 !important;
  }
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "PrognosticDetails",
  components: {},
  props: {
    matchDetails: {},
  },
  data: () => ({
    prognostics: [
      {
        name: "1x2",
        bets: [
          {
            value: "V1",
            odd: "1.25",
            bank: "1%",
          },
          {
            value: "X",
            odd: "1.25",
            bank: "1%",
          },
        ],
      },
      {
        name: "Para se qualificar",
        bets: [
          {
            value: "Equipa casa",
            odd: "1.25",
            bank: "1%",
          },
        ],
      },
      {
        name: "Golos em ambas as partes",
        bets: [
          {
            value: "Sim",
            odd: "1.25",
            bank: "1%",
          },
        ],
      },
      {
        name: "Total individual",
        bets: [
          {
            value: "Acima 0.5",
            odd: "1.25",
            bank: "1%",
          },
          {
            value: "Acima 1.5",
            odd: "1.25",
            bank: "1%",
          },
          {
            value: "Acima 2.5",
            odd: "1.25",
            bank: "1%",
          },
        ],
      },
      {
        name: "Auto-Golo",
        bets: [
          {
            value: "Sim",
            odd: "1.25",
            bank: "1%",
          },
        ],
      },
    ],
    selectBets: new Map(),
    showBigoddsPrognostics: false,
  }),
  methods: {
    selectBet(bet) {
      const key = bet.key;
      const value = bet.value;

      if (this.selectBets.has(key)) {
        if (this.selectBets.get(key) == value) {
          // If already selected, then deselect it
          this.selectBets.delete(bet.key);
          this.$refs[key + "-" + value][0].clearSelection();
        } else {
          // If new selection, then deselect previous and add new one
          this.$refs[key + "-" + this.selectBets.get(key)][0].clearSelection();
          this.selectBets.set(bet.key, bet.value);
        }
      } else {
        this.selectBets.set(bet.key, bet.value);
      }
    },
    submitBet() {
      console.log(this.selectBets);
    },
    closeDialog() {
      this.$emit("close-dialog");
    },
    isTiroCerteiro() {
      return this.$route.path.includes("tiro-certeiro");
    },
    isBigometro() {
      return this.$route.path.includes("bigometro");
    },
    marketMap(markets) {
      return this.$lodash.groupBy(markets, "market.name");
    },
  },
  computed: {
    totalBank() {
      let total = 0;
      this.matchDetails.matchMarkets.forEach((market) => {
        if (market.bigoddsMarkets) {
          market.bigoddsMarkets.forEach((item) => {
            total += item.bank;
          });
        }
      });
      return total;
    },
    totalOdd() {
      let total = 0;
      this.matchDetails.matchMarkets.forEach((market) => {
        if (market.bigoddsMarkets) {
          market.bigoddsMarkets.forEach((item) => {
            //total = total * item.odd;
            total == 0 ? (total = 1 * item.odd) : (total = total * item.odd);
          });
        }
      });
      return total.toFixed(2);
    },
  },
});
</script>
